var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXMarkOutline2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0.00001,
    fill: "none",
    height: 32,
    width: 32
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m16,31.00002a3.9,3.9 0 0 1 -1.92,-0.5l-10.18,-5.67a3.63,3.63 0 0 1 -1.9,-3.16l0,-11.35a3.64,3.64 0 0 1 1.89,-3.15l10.19,-5.68a4,4 0 0 1 1.92,-0.49a3.91,3.91 0 0 1 1.93,0.5l10.17,5.67a3.63,3.63 0 0 1 1.9,3.16l0,11.35a3.64,3.64 0 0 1 -1.89,3.15l-10.19,5.68a4,4 0 0 1 -1.92,0.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#04A6FC",
    d: "m16,2.00001a2.92,2.92 0 0 1 1.42,0.37l10.2,5.68a2.64,2.64 0 0 1 1.38,2.27l0,11.34a2.66,2.66 0 0 1 -1.38,2.34l-10.18,5.63a3,3 0 0 1 -1.44,0.37a3,3 0 0 1 -1.43,-0.37l-10.2,-5.63a2.64,2.64 0 0 1 -1.37,-2.32l0,-11.34a2.66,2.66 0 0 1 1.38,-2.34l10.18,-5.63a3,3 0 0 1 1.44,-0.37l0,0m0,-2l0,0a4.93,4.93 0 0 0 -2.4,0.62l-10.19,5.68a4.62,4.62 0 0 0 -2.41,4l0,11.38a4.62,4.62 0 0 0 2.41,4l10.18,5.68a5,5 0 0 0 4.82,0l10.18,-5.66a4.62,4.62 0 0 0 2.41,-4l0,-11.38a4.62,4.62 0 0 0 -2.41,-4l-10.18,-5.7a4.93,4.93 0 0 0 -2.41,-0.62z"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "null"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    strokeMiterlimit: 10,
    fill: "#fc5834",
    d: "m11.27264,9.49987c-0.15121,0 -0.30257,0.05317 -0.4178,0.15981l-1.18184,1.09093c-0.23105,0.21328 -0.23105,0.55859 0,0.77132l4.30956,3.97807l-4.30956,3.97807c-0.23105,0.21328 -0.23105,0.55859 0,0.77132l1.18184,1.09093c0.23105,0.21328 0.60514,0.21328 0.8356,0l4.30956,-3.97807l4.30956,3.97807c0.23046,0.21328 0.60514,0.21328 0.83559,0l1.18184,-1.09093c0.23105,-0.21327 0.23105,-0.55859 0,-0.77132l-4.30956,-3.97807l4.30956,-3.97807c0.23105,-0.21273 0.23105,-0.55859 0,-0.77132l-1.18184,-1.09093c-0.23105,-0.21328 -0.60514,-0.21328 -0.83559,0l-4.30956,3.97807l-4.30956,-3.97807c-0.11553,-0.10664 -0.26659,-0.15981 -0.4178,-0.15981z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXMarkOutline2);
export default __webpack_public_path__ + "static/media/XMarkOutline2.633a098581a0bf5fcea625f52cccd9d7.svg";
export { ForwardRef as ReactComponent };